module.exports = __webpack_public_path__ + "img/gold-silver-badge-old-small.d3faf5d4.png";